import forEach from 'lodash/forEach';
import get from 'lodash/get';
import toNumber from 'lodash/toNumber';

import { canUseDOM } from 'exenv';
import identityConfig from '../../../config/identity';
import { figureOutPriorityTag } from '../../../utils/ad_util';

export default function loadGATracker(currentState, pageNumber = 0) {
  // https://developers.google.com/analytics/devguides/collection/analyticsjs/
  if (window.ga) {
    const { ga } = window;
    const siteConfig =
      identityConfig[get(currentState, 'context.site', 'fastcompany')];
    const siteSlug = get(siteConfig, 'slug');
    const context = get(currentState, 'context');

    const {
      postData,
      tagPageData,
      categoryPageData,
      mostCreativePeoplePageData,
      micSectorPageData,
      ibdPageData,
      productPageData,
      micPageData,
      type
    } = context;

    let category = '';
    let tag = '';

    if (get(currentState, 'config.featureFlags.gaCustomVarEnabled')) {
      // config here: https://analytics.google.com/analytics/web/#management/Settings/a45063514w75598220p78098335/%3Fm.page%3DPropertySettings/
      let legacyDomain = siteSlug;
      let customDimensions = [
        { 'Legacy Domain': legacyDomain },
        { 'Content Type': 'homepage' },
        { Tag: 'Unassigned' },
        { Category: 'Unassigned' },
        { Contributor: 'Fast Company' },
        { Editor: 'Fast Company' },
        { 'Publication Date': '1/1/1990' },
        { 'Minutes Length': 0 },
        { 'Scroll Page Number': 0 }
      ];
      const typeLookup = {
        post() {
          category = get(postData, 'categories[0].slug', 'technology');
          const tags = get(postData, 'tags');
          const eyeBrowText = figureOutPriorityTag(tags);

          let bylineAttribution = null;

          forEach(tags, tagObj => {
            if (
              tagObj.name.indexOf('byline_') !== -1 ||
              tagObj.slug.indexOf('byline-') !== -1
            ) {
              bylineAttribution = tagObj.name.replace('byline_', '');
            }
          });

          // For mapping of language, anaytics need to be consistent, language wise
          let pageType = 'unassigned';
          if (get(postData, 'posterSlideshow.length')) {
            pageType = 'slideshow';
          } else if (
            get(postData, 'hasVideoPoster') === true ||
            get(postData, 'posterVideo.feedId')
          ) {
            pageType = 'video';
          } else {
            pageType = 'article';
          }

          if (category === 'ideas') {
            legacyDomain = 'Fastcoexist.com';
          } else if (category === 'entertainment') {
            legacyDomain = 'FastcoCreate.com';
          } else if (category === 'news') {
            legacyDomain = 'News';
          }

          let minutesRead = get(postData, 'readTime');
          if (minutesRead !== 'long') {
            minutesRead = toNumber(minutesRead.replace(' minute', '')) || '0';
          }

          customDimensions = [
            { 'Legacy Domain': legacyDomain },
            { Category: category },
            { 'Publication Date': get(postData, 'omnitureDate') },
            { 'Content Type': pageType },
            { 'Minutes Length': minutesRead },
            {
              'Scroll Page Number':
                pageNumber !== 0 ? pageNumber - 1 : pageNumber
            }
          ];

          if (bylineAttribution) {
            customDimensions.push({ Contributor: bylineAttribution });
            customDimensions.push({
              Editor: get(postData, 'author.name', 'Fast Company')
            });
          } else {
            customDimensions.push({
              Contributor: get(postData, 'author.name')
            });
            customDimensions.push({ Editor: 'Fast Company' });
          }

          const eyeBrowTag = get(eyeBrowText, 'name');
          if (eyeBrowTag !== '') {
            customDimensions.push({ Tag: eyeBrowTag });
          } else {
            customDimensions.push({ Tag: 'notag' });
          }
        },
        category() {
          category = get(categoryPageData, 'slug');
          customDimensions = [
            { 'Legacy Domain': legacyDomain },
            { Category: category },
            { 'Content Type': 'category page' },
            { Tag: 'notag' },
            { Contributor: 'Fast Company' },
            { Editor: 'Fast Company' },
            { 'Publication Date': '1/1/1990' },
            { 'Minutes Length': 0 },
            { 'Scroll Page Number': 0 }
          ];
        },
        tag() {
          tag = get(tagPageData, 'name');
          customDimensions = [
            { 'Legacy Domain': legacyDomain },
            { Tag: tag },
            { 'Content Type': 'section page' },
            { Category: 'Unassigned' },
            { Contributor: 'Fast Company' },
            { Editor: 'Fast Company' },
            { 'Publication Date': '1/1/1990' },
            { 'Minutes Length': 0 },
            { 'Scroll Page Number': 0 }
          ];
        },
        author() {
          customDimensions = [
            { 'Legacy Domain': legacyDomain },
            { 'Content Type': type },
            { Tag: 'Unassigned' },
            { Category: 'Unassigned' },
            { Contributor: 'Fast Company' },
            { Editor: 'Fast Company' },
            { 'Publication Date': '1/1/1990' },
            { 'Minutes Length': 0 },
            { 'Scroll Page Number': 0 }
          ];
        },
        search() {
          customDimensions = [
            { 'Legacy Domain': legacyDomain },
            { 'Content Type': type },
            { Tag: 'Unassigned' },
            { Category: 'Unassigned' },
            { Contributor: 'Fast Company' },
            { Editor: 'Fast Company' },
            { 'Publication Date': '1/1/1990' },
            { 'Minutes Length': 0 },
            { 'Scroll Page Number': 0 }
          ];
        },
        page() {
          customDimensions = [
            { 'Legacy Domain': legacyDomain },
            { 'Content Type': type },
            { Tag: 'Unassigned' },
            { Category: 'Unassigned' },
            { Contributor: 'Fast Company' },
            { Editor: 'Fast Company' },
            { 'Publication Date': '1/1/1990' },
            { 'Minutes Length': 0 },
            { 'Scroll Page Number': 0 }
          ];
        },
        personPage() {
          customDimensions = [
            { 'Legacy Domain': legacyDomain },
            { 'Content Type': 'person page' },
            { Tag: 'Unassigned' },
            { Category: 'person' },
            { Contributor: 'Fast Company' },
            { Editor: 'Fast Company' },
            { 'Publication Date': '1/1/1990' },
            { 'Minutes Length': 0 },
            { 'Scroll Page Number': 0 }
          ];
        },
        personIndexSectionPage() {
          customDimensions = [
            { 'Legacy Domain': legacyDomain },
            { 'Content Type': 'person index page' },
            { Tag: 'Unassigned' },
            { Category: 'person' },
            { Contributor: 'Fast Company' },
            { Editor: 'Fast Company' },
            { 'Publication Date': '1/1/1990' },
            { 'Minutes Length': 0 },
            { 'Scroll Page Number': 0 }
          ];
        },
        mostCreativePeoplePage() {
          const year = get(mostCreativePeoplePageData, 'year', '');
          customDimensions = [
            { 'Legacy Domain': legacyDomain },
            { 'Content Type': 'mcp page' },
            { Tag: `mcp${year}` },
            { Category: 'mcp' },
            { Contributor: 'Fast Company' },
            { Editor: 'Fast Company' },
            { 'Publication Date': '1/1/1990' },
            { 'Minutes Length': 0 },
            { 'Scroll Page Number': 0 }
          ];
        },
        mostCreativePeopleCommunityPage() {
          customDimensions = [
            { 'Legacy Domain': legacyDomain },
            { 'Content Type': 'mcp community page' },
            { Tag: 'Unassigned' },
            { Category: 'mcp' },
            { Contributor: 'Fast Company' },
            { Editor: 'Fast Company' },
            { 'Publication Date': '1/1/1990' },
            { 'Minutes Length': 0 },
            { 'Scroll Page Number': 0 }
          ];
        },
        micSectorPage() {
          const year = get(micSectorPageData, 'year', '');
          customDimensions = [
            { 'Legacy Domain': legacyDomain },
            { 'Content Type': 'mic sector page' },
            { Tag: `mic${year}` },
            { Category: 'mic' },
            { Contributor: 'Fast Company' },
            { Editor: 'Fast Company' },
            { 'Publication Date': '1/1/1990' },
            { 'Minutes Length': 0 },
            { 'Scroll Page Number': 0 }
          ];
        },
        companyIndexSectionPage() {
          customDimensions = [
            { 'Legacy Domain': legacyDomain },
            { 'Content Type': 'company sector index page' },
            { Tag: 'Unassigned' },
            { Category: 'mic' },
            { Contributor: 'Fast Company' },
            { Editor: 'Fast Company' },
            { 'Publication Date': '1/1/1990' },
            { 'Minutes Length': 0 },
            { 'Scroll Page Number': 0 }
          ];
        },
        ibdPage() {
          const year = get(ibdPageData, 'year', '');
          customDimensions = [
            { 'Legacy Domain': legacyDomain },
            { 'Content Type': 'ibd page' },
            { Tag: `ibd${year}` },
            { Category: 'ibd' },
            { Contributor: 'Fast Company' },
            { Editor: 'Fast Company' },
            { 'Publication Date': '1/1/1990' },
            { 'Minutes Length': 0 },
            { 'Scroll Page Number': 0 }
          ];
        },
        companyPage() {
          customDimensions = [
            { 'Legacy Domain': legacyDomain },
            { 'Content Type': 'company page' },
            { Tag: 'company' },
            { Category: 'company' },
            { Contributor: 'Fast Company' },
            { Editor: 'Fast Company' },
            { 'Publication Date': '1/1/1990' },
            { 'Minutes Length': 0 },
            { 'Scroll Page Number': 0 }
          ];
        },
        productPage() {
          const productName = get(productPageData, 'data.rows[0].name');
          customDimensions = [
            { 'Legacy Domain': legacyDomain },
            { 'Content Type': 'product page' },
            { Tag: `product:${productName}` },
            { Category: 'product' },
            { Contributor: 'Fast Company' },
            { Editor: 'Fast Company' },
            { 'Publication Date': '1/1/1990' },
            { 'Minutes Length': 0 },
            { 'Scroll Page Number': 0 }
          ];
        },
        micYearPage() {
          const year = get(micPageData, 'year', '');
          customDimensions = [
            { 'Legacy Domain': legacyDomain },
            { 'Content Type': 'mic year page' },
            { Tag: `mic${year}` },
            { Category: 'mic' },
            { Contributor: 'Fast Company' },
            { Editor: 'Fast Company' },
            { 'Publication Date': '1/1/1990' },
            { 'Minutes Length': 0 },
            { 'Scroll Page Number': 0 }
          ];
        },
        magazineArchivePage() {
          customDimensions = [
            { 'Legacy Domain': legacyDomain },
            { 'Content Type': 'magazine archives page' },
            { Tag: 'magazine' },
            { Category: 'magazine' },
            { Contributor: 'Fast Company' },
            { Editor: 'Fast Company' },
            { 'Publication Date': '1/1/1990' },
            { 'Minutes Length': 0 },
            { 'Scroll Page Number': 0 }
          ];
        }
      };

      if (typeLookup[type]) {
        typeLookup[type]();
      }

      forEach(customDimensions, dimension => {
        if (!dimension) {
          return;
        }
        const key = Object.keys(dimension)[0];
        const dimensionKey = dimension[key];
        ga('set', `${key}`, `${dimensionKey}`);
        ga('rollup.set', `${key}`, `${dimensionKey}`);
      }).join('');
    }

    const pathanme = window.location.pathname;
    ga('set', 'page', pathanme);
    ga('send', 'pageview');
    ga('rollup.set', 'page', pathanme);
    ga('rollup.send', 'pageview');
  }
}

export function trackGAEvent(eventParams) {
  if (canUseDOM) {
    if (window && window.ga) {
      const { eventCategory, eventAction, eventLabel = null } = eventParams;
      if (eventCategory && eventAction) {
        window.ga('send', 'event', eventCategory, eventAction, eventLabel);
        window.ga(
          'rollup.send',
          'event',
          eventCategory,
          eventAction,
          eventLabel
        );
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/client/utils/third_party_trackers/ga.js